import React from 'react';
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { VariableEditorProps } from '../types';

export const StringEditor: React.FC<VariableEditorProps> = ({
  variable,
  value,
  onChange,
  error,
  disabled,
}) => {
  const [showSensitive, setShowSensitive] = React.useState(false);
  const stringValue = (value as string) ?? '';

  // Check if this has enum validation (select dropdown)
  const enumValues = variable.validation?.find(v => v.enum)?.enum;

  if (enumValues && enumValues.length > 0) {
    return (
      <FormControl
        fullWidth
        variant="outlined"
        size="small"
        error={!!error}
        disabled={disabled}
      >
        <InputLabel>{variable.name}</InputLabel>
        <Select
          value={stringValue}
          onChange={e => onChange(e.target.value)}
          label={variable.name}
        >
          {enumValues.map(opt => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
        {(error || variable.description) && (
          <FormHelperText error={!!error}>
            {error || variable.description}
          </FormHelperText>
        )}
      </FormControl>
    );
  }

  // Check for pattern validation
  const patternRule = variable.validation?.find(v => v.pattern);

  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      label={variable.name}
      value={stringValue}
      onChange={e => onChange(e.target.value)}
      error={!!error}
      helperText={error || variable.description}
      disabled={disabled}
      type={variable.sensitive && !showSensitive ? 'password' : 'text'}
      placeholder={
        variable.currentValue !== undefined
          ? `Current: ${variable.currentValue}`
          : variable.default !== undefined
            ? `Default: ${variable.default}`
            : undefined
      }
      inputProps={{
        pattern: patternRule?.pattern,
      }}
      InputProps={
        variable.sensitive
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setShowSensitive(!showSensitive)}
                    edge="end"
                  >
                    {showSensitive ? (
                      <VisibilityOffIcon fontSize="small" />
                    ) : (
                      <VisibilityIcon fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};
